import DataObject from "../DataObject";

export default class VMSEnumeration {
  Name: string = "";
  Items: DataObject = new DataObject();
}
